// import React, { useContext, useEffect, useState } from 'react'
// import { ShopContext } from '../context/ShopContext'
// import Title from './Title';
// import ProductItem from './ProductItem';

// const RelatedProducts = ({category,subCategory}) => {

//     const { products } = useContext(ShopContext);
//     const [related,setRelated] = useState([]);

//     useEffect(()=>{

//         if (products.length > 0) {
            
//             let productsCopy = products.slice();
            
           

//             setRelated(productsCopy.slice(0,5));
//         }
        
//     },[products])

//   return (
//     <div className='my-24'>
//       <div className=' text-center text-3xl py-2'>
//         <Title text1={'RELATED'} text2={"PRODUCTS"} />
//       </div>

//       <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 gap-y-6'>
//         {related.map((item,index)=>(
//             <ProductItem key={index} id={item._id} image={item.image} name={item.name} price={item.price} op={item.originalPrice} importance="high" />
//         ))}    
//       </div>
//     </div>
//   )
// }

// export default RelatedProducts





//  // productsCopy = productsCopy.filter((item) => category === item.category);
//             // productsCopy = productsCopy.filter((item) => subCategory === item.subCategory);





import React, { useContext, useEffect, useState } from 'react';
import { ShopContext } from '../context/ShopContext';
import Title from './Title';
import ProductItem from './ProductItem';

const RelatedProducts = ({ category, subCategory }) => {
  const { products } = useContext(ShopContext);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    if (products.length > 0) {
      // Shuffle the products array using Fisher-Yates algorithm
      let shuffled = [...products].sort(() => 0.5 - Math.random());
      
      // Select the first 5 random products
      setRelated(shuffled.slice(0, 5));
    }
  }, [products]);

  return (
    <div className='my-24'>
      <div className='text-center text-3xl py-2'>
        <Title text1={'RELATED'} text2={'PRODUCTS'} />
      </div>

      <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 gap-y-6'>
        {related.map((item, index) => (
          <ProductItem
            key={index}
            id={item._id}
            image={item.image}
            name={item.name}
            price={item.price}
            op={item.originalPrice}
            importance='high'
          />
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;

